import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { ReactNode } from "react";

interface Props {
  error?: boolean | string;
  isActive?: boolean;
  children: ReactNode;
  [rest: string]: any;
  styles?: object;
}

const QuestionBox = ({
  children,
  error,
  isActive,
  rest,
  styles = {},
}: Props) => {
  const getBorderColor = () => {
    if (error) {
      return "error.main";
    } else if (isActive) {
      return "#165C4E";
    } else {
      return grey[300];
    }
  };

  return (
    <Box
      {...rest}
      sx={[
        {
          border: "1px solid",
          borderColor: getBorderColor(),
          borderRadius: 3,
          p: 3,
          mb: 2,
        },
        styles,
      ]}
    >
      <Typography variant="caption" sx={{ color: "error.main" }}>
        {error}
      </Typography>
      {children}
    </Box>
  );
};

export default QuestionBox;
